type Listener = (valueName: string) => void

export class RouterValueListeners {
  private static listeners: Record<string, Listener[]> = {}

  static listen(valueName: string, listener: Listener) {
    if (!RouterValueListeners.listeners[valueName])
      RouterValueListeners.listeners[valueName] = []

    RouterValueListeners.listeners[valueName].push(listener)
    return () => {
      RouterValueListeners.listeners[
        valueName
      ] = RouterValueListeners.listeners[valueName].filter(
        fn => fn !== listener,
      )
    }
  }

  static notify(valueName: string) {
    RouterValueListeners.listeners[valueName]?.forEach(fn => fn(valueName))
  }
}

export function onRouterValueChanged(valueName: string, fn: Listener) {
  RouterValueListeners.listen(valueName, fn)
}
